import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogoLoader } from "@/components/LogoLoader";
import { canModerateForum } from "@/lib/accountRole";

// Route guard for the forum-moderation surface (/mod). Login-gated, then forum-moderator-gated.
// A non-moderator (or a plain member) is bounced to the feed — /mod is forum-only and never
// exposes any other admin capability.
export default function ForumModRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <LogoLoader />;
  if (!user) return <Navigate to="/join" replace />;
  if (!canModerateForum(user)) return <Navigate to="/feed" replace />;
  return children;
}
